export const LOCATION_TYPE_DEFAULT = 0;

export const LOCATION_TYPE_SPEEDDATE = 1;
